export default __webpack_public_path__ + "static/media/Banner - Elevate Pro - Yellow.f58f581c.jpg";